import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {library} from '@fortawesome/fontawesome-svg-core';
import ModalFileParameters from './components/ModalFileParameters';
import ModalDocParameters from './components/ModalDocParameters';
import objeler from './components/objeler';
import './index.css';
import {
    faAlignCenter,
    faAlignLeft,
    faAlignRight,
    faBarcode,
    faBuilding,
    faCalendarAlt,
    faCircle,
    faEnvelope,
    faFileWord,
    faGavel,
    faImage,
    faPenSquare,
    faPhone,
    faSearch,
    faSlash,
    faSquare,
    faStamp,
    faTable,
    faTextWidth,
    faTrash,
    faSlidersH
} from '@fortawesome/free-solid-svg-icons';
import store from './redux/store';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {positions, Provider as AlertProvider, transitions} from './react-alert-master/src'
import AlertTemplate from './AlertTemplate'
import ModalAlert from "./components/ModalDialog/ModalAlert"
import './i18n';
import './css/Frame.css';

// ──────────────────────────────────────────────────────────────────
// M3.5/H4 — Production console silencer
// ──────────────────────────────────────────────────────────────────
// In a production build, every console.log/info/debug becomes a no-op.
// console.error and console.warn are KEPT — production-time error
// reporting (Sentry, Bugsnag, vendor tools) hooks into them, and
// silencing those would hide real failures.
//
// This is defense in depth: sensitive console.log lines (token leaks,
// account context) have already been removed at source in Login.js
// and Direct.js — but a stray future addition shouldn't be able to
// leak in production.
// ──────────────────────────────────────────────────────────────────
if (process.env.NODE_ENV === 'production') {
    const noop = () => {};
    console.log   = noop;
    console.info  = noop;
    console.debug = noop;
    console.trace = noop;
    // .warn ve .error KORUNUR — error reporters bunlara wire'lanır,
    // production exception'ları bu kanaldan görünmeli.
}

library.add(faGavel);
library.add(faBuilding);
library.add(faEnvelope);
library.add(faPhone);
library.add(faCalendarAlt);
library.add(faTrash);
library.add(faAlignLeft);
library.add(faAlignCenter);
library.add(faAlignRight);
library.add(faSquare);
library.add(faSlash);
library.add(faCircle);
library.add(faStamp);
library.add(faImage);
library.add(faTextWidth);
library.add(faFileWord);
library.add(faBarcode);
library.add(faSearch);
library.add(faPenSquare);
library.add(faSlidersH);
library.add(faTable);
const root = document.getElementById('root');
objeler['ModalFileParameters'] = ModalFileParameters;
objeler['ModalDocParameters'] = ModalDocParameters;
objeler['ShowLoader'] = false;
objeler.ModalFileParameters = ({Type: '', Title: '', FileName: 'untitled', IsNew: 1});
const options = {
    position: positions.MIDDLE,
    timeout: 2500,
    offset: '60px',
    transition: transitions.SCALE
};
if (root !== null) {
    ReactDOM.render(
        <Provider store={store}>
            <AlertProvider template={AlertTemplate} templateDialog={ModalAlert} {...options}>
                <App/>
            </AlertProvider>
        </Provider>,
        root
    );
}
serviceWorkerRegistration.unregister();
